import { connect } from 'react-redux'
import { withRouter, browserHistory } from 'react-router'
import { getTranslate } from 'react-localize-redux'
import cx from 'classnames'

import { getSelectedProject } from 'common/selectors/projects'
import * as Routes from 'constants/Routes'
import styles from './Navbar.module.scss'

import UserMenu from 'common/components/UserMenu/UserMenu'
import { InbiotLogo, MyWorkspaceIcon, AccountSettingsIcon, ProjectFolderIcon } from 'icons'

const WORKSPACE_PATHS = [Routes.PROJECTS, Routes.DEVICES, Routes.INTEGRATIONS]

/**
 * The top bar (MI--T45): logo on the left (goes to My Workspace), the page
 * icon and title in the center, and the account menu (hamburger) on the right.
 * It replaces the old AuxHeader, Header, ProjectHeader and MobileHeader.
 * The tab row is a separate component (NavTabs).
 */
const Navbar = ({ translate, projectName, location }) => {
  const { pathname } = location

  const resolveContext = () => {
    if (WORKSPACE_PATHS.some(path => pathname.includes(path))) {
      return { icon: MyWorkspaceIcon, title: translate('myWorkspace'), isProject: false }
    }
    if (pathname.includes(Routes.PROFILE)) {
      return { icon: AccountSettingsIcon, title: translate('accountSettings'), isProject: false }
    }
    return { icon: ProjectFolderIcon, title: projectName, isProject: true }
  }

  const { icon, title, isProject } = resolveContext()

  return (
    <header className={styles.navbar}>
      <button
        type='button'
        className={styles.logoButton}
        aria-label={translate('myWorkspace')}
        onClick={() => browserHistory.push(Routes.PROJECTS)}
      >
        <img
          src={InbiotLogo}
          className={styles.logo}
          alt='inBiot'
        />
      </button>

      <div className={styles.context}>
        <img
          src={icon}
          className={styles.contextIcon}
          alt=''
        />
        <span className={cx(styles.title, { [styles.projectTitle]: isProject })}>{title}</span>
      </div>

      <div className={styles.actions}>
        <UserMenu />
      </div>
    </header>
  )
}

const mapStateToProps = state => ({
  translate: getTranslate(state.localize),
  projectName: getSelectedProject(state)?.toJS()?.Meta?.name
})

export default withRouter(connect(mapStateToProps)(Navbar))
